<template>
  <div>
    <SectionsProcessQuoteHeader :banner-title="routeComponentParams.bannerTitle" />
    <v-container>
      <component 
        :is="routeComponentParams.component"
        :stepId="routeComponentParams.stepId"
        :formTitle="routeComponentParams.title"
      ></component>
    </v-container>
  </div>
</template>

<script lang="ts" setup>  
import { FormsQuoteStart, FormsQuoteTiers, FormsQuoteReview } from '#components';

  useHead({
    title: useRuntimeConfig().public.applicationTitle + " - Instant Quote",
      meta: [
        {name: "description", content: useRuntimeConfig().public.applicationDescription}, 
      ],
      bodyAttrs: {
        class: "navbar-dark navbar-fill scheme-emerge"
      },
  }) 

  const routeComponentParams = computed(() => {
    const routeParamsId = useRoute().params?.id as string;
    switch(routeParamsId.toLowerCase()) {
      case "start":
        return {
          component: FormsQuoteStart,
          stepId: "STEP01",
          title: "Let's Get Started",
          bannerTitle: "Instant Quote",
        };
      case "tiers":
        return {
          component: FormsQuoteTiers,
          stepId: "STEP02",
          title: "Choose who you would like to cover",
          bannerTitle: "Get Your Quote",
        };
      case "review":
        return {
          component: FormsQuoteReview,
          stepId: "STEP03",
          title: "",
          bannerTitle: "Review Your Benefits",
        };
      default:
        throw createError({
          status: 404, 
          statusText: `Page (FormsQuote${routeParamsId.charAt(0).toUpperCase() + routeParamsId.slice(1)}) not found`
        });
    }
  })
  
</script>